import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n);
import vuetify from './plugins/vuetify'
Vue.config.productionTip = false

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: "AIzaSyCgK21I8Hz_ulxmY5nMFRGI5j9BvETmw8Y",
  authDomain: "iz-one.firebaseapp.com",
  databaseURL: "https://iz-one-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "iz-one",
  storageBucket: "iz-one.appspot.com",
  messagingSenderId: "973823070535",
  appId: "1:973823070535:web:52855729bc5dc114e2bc62",
  measurementId: "G-HDPWZHD0W4"
};

// Initialize Firebase
initializeApp(firebaseConfig);

import { getAuth, onAuthStateChanged } from 'firebase/auth'
const auth = getAuth();
onAuthStateChanged(auth, user => {
  store.dispatch("fetchUser", user);
});


// Initialize i18n
const i18n = new VueI18n({
  locale: navigator.language,
  fallbackLocale: "en"
});

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')
